import WAValidator from 'wallet-address-validator'

export function validateAddress (address, asset = 'ETH') {
  if (isETHAddress(address)) return true
  if (isBTCAddress(address)) return true
  if (isTaurusAddress(address)) return true
  return false
}

function isETHAddress (address) {
  return /^(0x)?[0-9a-f]{40}$/i.test(address)
}

function isBTCAddress (address) {
  return WAValidator.validate(address, 'BTC', 'both')
}

function isTaurusAddress (address) {
  if (address.length > 6 && (/[0-9]$/i.test(address))) {
    let i = parseInt(address, 10)
    let maxUint = (1 << 32)
    return (i > 999999 && i < maxUint)
  }
  return false
}



// WEBPACK FOOTER //
// ./src/validator/address_validation.js